import { render } from "./작성글_접수_상세페이지.vue?vue&type=template&id=74f48569"
import script from "./작성글_접수_상세페이지.vue?vue&type=script&lang=js"
export * from "./작성글_접수_상세페이지.vue?vue&type=script&lang=js"

import "./작성글_접수_상세페이지.vue?vue&type=style&index=0&id=74f48569&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__